export const PUT_USER = '@LOGIN/PUT_USER';

export const actionCreators = {
    putUser: (user) =>  ({ type: PUT_USER, payload: user })
}
